module.exports = __webpack_public_path__ + "static/img/total_volume.b8b9cbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/total_volume.png
// module id = /MEE
// module chunks = 0